<template>
    <router-link class="conversation"
                 :to="{ name: 'conversations.conversation', params: { id: conversation.id }}">
        <div class="columns" :class="{'project-open': isOpen(conversation), 'no-project': noProject}">
            <div class="column is-narrow">
                <avatar v-if="isSender(conversation)" :size="40" round :account="conversation.addressee" />

                <avatar v-else :size="40" round :account="conversation.sender" />
            </div>

            <div class="column">
                <small class="has-text-grey">
                    {{isSender(conversation) ? conversation.addressee.name : conversation.sender.name}}
                    <template v-if="conversation.latest_message">&nbsp;-&nbsp;{{conversation.latest_message.sent_at | formatTimeAgo}}</template>
                </small>
                <br>
                
                {{title}} <br>


                <small class="has-text-grey" v-if="conversation.latest_message">
                    {{isSender(conversation.latest_message) ? 'Dig:' : '' }}
                    {{conversation.latest_message.content | limitString(40)}}
                </small>

                <small class="has-text-grey" v-else>
                    Ingen beskeder
                </small>
            </div>
        </div>
    </router-link>
</template>

<style lang="scss" scoped>
    @import '../../../global/styles/variables';

    .project-open {
        background: rgba(0,255,0,0.05) !important;
    }
    .no-project {
        background: rgba(0,0,0,0.05) !important;
    }
    .conversation {
        &.is-active {
            background: whitesmoke;
            color: $primary;
        }

        &:hover, &:focus {
            cursor: pointer;
            background: whitesmoke;
            color: $primary;
            box-shadow: 0 2px 3px rgba(10, 10, 10, 0.1), 0 0 0 1px rgba(10, 10, 10, 0.1);
        }
    }

</style>

<script>
    import Avatar from '@/taskflex/users/components/Avatar';
    import { mapGetters } from 'vuex';

    export default {
        props: {
            conversation: {
                required: true,
                type: Object,
            },
        },

        computed: {
            noProject() {
                return !this.conversation.project || this.conversation.project.openStatus === false;
            },
            ...mapGetters('auth', [
                'currentUserAccount',
            ]),

            type() {
                const {
                    addressee,
                    sender,
                } = this.conversation;

                return this.$t(`global.account.${this.isSender(this.conversation) ? addressee.type : sender.type}`);
            },

            title() {
                const {
                    project,
                } = this.conversation;

                if (!project) {
                    return this.type;
                }

                // TODO: check if starts with project
                return project.name;
            },
        },

        methods: {
            isOpen(conversation) {
                return conversation.project && conversation.project.openStatus && conversation.project.openStatus === true;
            },
            isSender(conversationOrMessage) {
                const {
                    sender,
                } = conversationOrMessage;

                return sender.id === this.currentUserAccount.id;
            },
        },

        components: {
            Avatar,
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/conversations/components/ConversationListItem.vue